import {
  Autocomplete,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import fetchcity from "../../common/fetchcity";
import toast from "react-hot-toast";
import moment from "moment";
import { BlinkBlur } from "react-loading-indicators";

const Addinquiry = ({ setActiveItem }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const fleetBookingStatus = JSON.parse(localStorage.getItem("catalogValues"))
    ?.fleetBookingStatus?.inverted?.inquiry;
  let profile = JSON.parse(localStorage.getItem("profile"));
  let fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  let transmissionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.transmissionType;
  let vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  let bookingTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  delete bookingTypes?.inverted;
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  let vehicleTypeData = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;
  const [pickupType, setPickupType] = useState("hubDelivery");
  const [dropType, setDropType] = useState("hubPickup");
  const [userList, setUserList] = useState([]);
  // const [selectedUser, setSelectedUser] = useState(null);
  const [cities, setCities] = useState(null);
  const [availableVehicles, setAvailableVehicles] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [discountMode, setDiscountMode] = useState(null);

  const [selectedTransmission, setSelectedTransmission] = useState("");
  const [selectedFuel, setSelectedFuel] = useState("");
  const [selectedBodyType, setSelectedBodyType] = useState("");
  const [filterAvailbaleVehciles, setFilterAvailableVehicles] = useState([]);
  const [priceType, setPriceType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [isElectric, setIsElectric] = useState(false);

  // useEffect(() => {
  //   if (availableVehicles) {
  //     setFilterAvailableVehicles(availableVehicles)
  //   }
  // } ,[availableVehicles])

  useEffect(() => {
    // clone to avoid mutating the original list
    let filteredData = [...filterAvailbaleVehciles];

    if (selectedTransmission) {
      filteredData = filteredData.filter(
        (item) => item.transmissionType === Number(selectedTransmission),
      );
    }

    if (selectedFuel) {
      filteredData = filteredData.filter(
        (item) => item.fuelType === Number(selectedFuel),
      );
    }

    if (selectedBodyType) {
      filteredData = filteredData.filter(
        (item) => item.bodyType === Number(selectedBodyType),
      );
    }

    if (priceType === "Low to High") {
      filteredData.sort((a, b) => a.totalRent - b.totalRent);
    } else if (priceType === "High to Low") {
      filteredData.sort((a, b) => b.totalRent - a.totalRent);
    }

    setAvailableVehicles(filteredData);
  }, [
    filterAvailbaleVehciles,
    selectedTransmission,
    selectedFuel,
    selectedBodyType,
    priceType,
  ]);

  const calculateFinalPrice = () => {
    if (!selectedVehicle) return 0;

    const baseFare =
      Number(selectedVehicle.weekdayRent || 0) +
      Number(selectedVehicle.weekendRent || 0);

    const pickupCharge = Number(inputValues?.pickupcharges || 0);
    const deliveryCharge = Number(inputValues?.deliverycharges || 0);
    const securityDeposit = Number(selectedVehicle?.securityDeposit || 0);

    if (discountMode === false) {
      // percentage discount
      const discount = Number(inputValues?.discount || 0);
      const discountedBase = Number(
        (baseFare - baseFare * (discount / 100)).toFixed(2),
      );
      const taxAmount = Number((discountedBase * 0.18).toFixed(2));

      const finalPrice = Number(
        (
          discountedBase +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2),
      );

      return { finalPrice, taxAmount, discountedBase };
    } else if (discountMode === true) {
      // fixed amount discount
      const discount = Number(inputValues?.discount || 0);
      if (discount > baseFare) {
        toast.error("Discount cannot be greater than base fare");
        return 0;
      }

      const discountedBase = Number((baseFare - discount).toFixed(2));
      const taxAmount = Number((discountedBase * 0.18).toFixed(2));

      const finalPrice = Number(
        (
          discountedBase +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2),
      );

      return { finalPrice, taxAmount, discountedBase };
    } else {
      // no discount
      const taxAmount = Number(selectedVehicle?.taxAmount || 0);

      const finalPrice = Number(
        (
          baseFare +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2),
      );

      return { finalPrice, taxAmount, discountedBase: baseFare };
    }
  };

  const getDiscountDetails = () => {
    if (!selectedVehicle) return { discountAmount: 0, discountPercentage: 0 };

    const baseFare =
      Number(selectedVehicle.weekdayRent || 0) +
      Number(selectedVehicle.weekendRent || 0);

    const discountValue = Number(inputValues?.discount || 0);

    if (!discountMode) {
      // % mode → user enters percentage
      const discountAmount = Math.round((baseFare * discountValue) / 100);
      return {
        discountAmount,
        discountPercentage: discountValue,
      };
    } else {
      // ₹ mode → user enters amount
      const discountAmount = discountValue;
      const discountPercentage = baseFare
        ? ((discountAmount / baseFare) * 100).toFixed(2)
        : 0;
      return {
        discountAmount,
        discountPercentage,
      };
    }
  };

  // const taxAmount = useMemo(() => {
  //   const baseFare =
  //     Number(selectedVehicle?.weekdayRent || 0) +
  //     Number(selectedVehicle?.weekendRent || 0);
  //   const discount = Number(inputValues?.discount || 0);
  //   let discountedBase
  //   if (!discountMode) {
  //     discountedBase = Math.round(baseFare - discount);
  //   } else {
  //     discountedBase = baseFare - discount;
  //   }
  //   return Math.round(discountedBase * 0.14 * 2);
  // }, [selectedVehicle, inputValues?.discount]);

  const taxAmount = useMemo(() => {
    const baseFare =
      Number(selectedVehicle?.weekdayRent || 0) +
      Number(selectedVehicle?.weekendRent || 0);

    const discountValue = Number(inputValues?.discount || 0);

    let discount = 0;

    if (!discountMode) {
      discount = (baseFare * discountValue) / 100;
    } else {
      discount = discountValue;
    }

    const discountedBase = baseFare - discount;

    return Number((discountedBase * 0.18).toFixed(2));
  }, [selectedVehicle, inputValues?.discount, inputValues?.discountType]);

  const customerInput = [
    {
      label: "Mobile",
      type: "autocomplete",
      value: "mobile",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "Customer Name",
      type: "text",
      value: "customerName",
      isEnable: false, // default false
      subCategory: [],
    },
    {
      label: "Email",
      type: "text",
      value: "email",
      isEnable: false, // default false
      subCategory: [],
    },
  ];

  let bookingsearchInput = [
    {
      label: "City",
      type: "dropdown",
      value: "city",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "Hub",
      type: "dropdown",
      value: "hub",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "Type of Rentals",
      type: "dropdown",
      value: "bookingTypes",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "KM Packages",
      type: "dropdown",
      value: "kmpackages",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "Start Date",
      type: "date",
      value: "startdate",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "Start Time",
      type: "time",
      value: "starttime",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "End Date",
      type: "date",
      value: "enddate",
      isEnable: false,
      subCategory: [],
    },
    {
      label: "End Time",
      type: "time",
      value: "endtime",
      isEnable: false,
      subCategory: [],
    },
  ];

  const [showButton, setShowButton] = useState(false);
  const [errors, setErrors] = useState({});

  const [defaultbookingInput, setdefaultbookinginput] =
    useState(bookingsearchInput);
  const isDailyRental =
    bookingTypes?.[inputValues?.bookingTypes] === "Daily Rental" ||
    inputValues?.bookingTypes === bookingTypesDuplicate?.inverted?.dailyRental;
  const isElectricRental =
    bookingTypes?.[inputValues?.bookingTypes] === "Electric Cars" ||
    inputValues?.bookingTypes === bookingTypesDuplicate?.inverted?.electricCars;
  const isBikesRental =
    bookingTypes?.[inputValues?.bookingTypes] === "Bikes" ||
    inputValues?.bookingTypes === bookingTypesDuplicate?.inverted?.bikes;
  const bookingTypeName = String(
    bookingTypes?.[inputValues?.bookingTypes] || "",
  ).toLowerCase();
  const bookingTypeKey = String(inputValues?.bookingTypes || "").toLowerCase();
  const isSubscriptionBooking = [bookingTypeName, bookingTypeKey].some(
    (value) => value.includes("subscription"),
  );

  useEffect(() => {
    if (!isSubscriptionBooking) return;

    setInputValues((prev) =>
      prev.endtime === prev.starttime
        ? prev
        : { ...prev, endtime: prev.starttime || "" },
    );
  }, [isSubscriptionBooking, inputValues?.starttime, inputValues?.endtime]);

  const getUserList = async (value) => {
    try {
      const response = await fetch(`${apiUrl}/api/users?mobile=${value}`);
      const data = await response.json();
      if (data?.entities?.rows.length > 0) {
        setUserList(data?.entities?.rows);
        setShowButton(false);
      } else {
        setShowButton(true);
        setUserList([]);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const validateField = (key, value) => {
    let error = "";

    if (!value || value.toString().trim() === "") {
      error = `${key} is required`;
    } else {
      switch (key) {
        case "mobile":
          if (!/^[0-9]{10}$/.test(value)) {
            error = "Enter a valid 10-digit mobile number";
          } else if (value.length > 10) {
            error = "Mobile number exceeds more than 10";
          }
          break;

        case "customerName":
          if (!/^[A-Za-z ]+$/.test(value)) {
            error = "Name must contain alphabets only";
          } else if (value.trim().length < 3) {
            error = "Name must be at least 3 characters";
          }
          break;

        case "email":
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
            error = "Enter a valid email";
          break;

        case "destination":
          if (value.length < 3) error = "Enter destination";
          break;

        // case "discount":
        //   if (!/^[0-9]+$/.test(value))
        //     error = "Only numbers allowed, no alphabets/special chars";
        //   break;

        case "pickupcharges":
        case "deliverycharges":
          if (!/^[0-9]+$/.test(value)) error = "Charges must be numeric only";
          break;

        case "deliveryaddress":
          if (value.trim().length < 5) error = "Delivery address required";
          break;

        case "pickupaddress":
          if (value.trim().length < 5) error = "Pickup address required";
          break;

        default:
          break;
      }
    }

    setErrors((prev) => ({ ...prev, [key]: error }));

    // // 🔔 Fire toast if error exists
    // if (error) {
    //   toast.error(error);
    // }

    return error === "";
  };

  useEffect(() => {
    setInputValues((prev) => ({
      ...prev,
      ["customerName"]: userList[0]?.name,
      ["email"]: userList[0]?.email,
      ["customerId"]: userList[0]?.id,
    }));
    setErrors({});
  }, [userList]);

  const resetVehicles = () => {
    setAvailableVehicles([]);
    setFilterAvailableVehicles([]);
    setSelectedVehicle(null);
    setLoading(false);
    setDiscountMode(null);
    setPickupType("hubDelivery");
    setDropType("hubPickup");
    setSelectedBodyType("");
    setSelectedFuel("");
    setSelectedTransmission("");
    setPriceType("");
  };

  const [discountSelection, setDiscountSelection] = useState(false);

  const resetTripDetails = () => {
    setPickupType("hubDelivery");
    setDropType("hubPickup");
    setDiscountMode(null);
    setDiscountSelection(false);
    setInputValues((prev) => ({
      ...prev,
      deliveryaddress: "",
      deliverycharges: "",
      pickupaddress: "",
      pickupcharges: "",
      destination: "",
      discount: "",
    }));
    setErrors((prev) => ({
      ...prev,
      deliveryaddress: "",
      deliverycharges: "",
      pickupaddress: "",
      pickupcharges: "",
      destination: "",
    }));
  };

  const handleInputChange = (event, inputKey) => {
    if (
      [...customerInput, ...bookingsearchInput].some(
        (input) => input.value === inputKey,
      )
    ) {
      resetTripDetails();
    }

    if (
      [
        "startdate",
        "starttime",
        "enddate",
        "endtime",
        "bookingTypes",
        "city",
        "hub",
        "kmpackages",
      ].includes(inputKey)
    ) {
      resetVehicles();
    }

    if (inputKey === "bookingTypes") {
      setInputValues((prev) => ({
        ...prev,
        bookingTypes: event?.target?.value || event,
        kmpackages: "",
      }));
      setErrors((prev) => ({
        ...prev,
        kmpackages: "",
      }));
      return;
    }
    if (inputKey === "startdate") {
      setInputValues((prev) => ({
        ...prev,
        starttime: "",
        enddate: "",
        endtime: "",
      }));
    }

    const value =
      event?.target?.value !== undefined ? event.target.value : event;

    if (inputKey === "mobile") {
      const mobileValue = typeof value === "object" ? value?.mobile : value;
      setInputValues((prev) => ({ ...prev, mobile: mobileValue }));
      validateField("mobile", mobileValue);

      if (mobileValue?.length === 10) {
        getUserList(mobileValue);
      }
      return;
    }

    if (inputKey === "discount" && discountMode === null) {
      setDiscountSelection(true);
      return;
    }

    setInputValues((prev) => ({
      ...prev,
      [inputKey]: value,
    }));

    validateField(inputKey, value);

    if (inputKey === "city") {
      getHubNames(value);
    }
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
        setdefaultbookinginput((prevInputs) =>
          prevInputs.map((input) => {
            if (input.value === "hub") {
              return {
                ...input,
                subCategory: data?.entities?.rows.map((item, index) => ({
                  sublabel: item?.hubName,
                  item: item?.id,
                })),
                isEnable: true,
              };
            }
            return input;
          }),
        );
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  // const validateAll = () => {
  //   let isValid = true;

  //   Object.keys(inputValues).forEach((key) => {
  //     // don't validate discount
  //     if (key === "discount") return;

  //     if (!validateField(key, inputValues[key])) isValid = false;
  //   });

  //   if (pickupType === "homeDelivery") {
  //     if (!validateField("deliveryaddress", inputValues?.deliveryaddress))
  //       isValid = false;
  //     if (!validateField("deliverycharges", inputValues?.deliverycharges))
  //       isValid = false;
  //   }

  //   if (dropType === "homePickup") {
  //     if (!validateField("pickupaddress", inputValues?.pickupaddress))
  //       isValid = false;
  //     if (!validateField("pickupcharges", inputValues?.pickupcharges))
  //       isValid = false;
  //   }
  //   console.log("validateAll =>", isValid);
  //   return isValid;
  // };

  const validateAll = () => {
    const required = [
      "mobile",
      "customerName",
      // "email",
      "city",
      "hub",
      "bookingTypes",
      "startdate",
      "starttime",
      "enddate",
      "endtime",
      "destination",
    ];

    if (isDailyRental || isElectricRental) required.push("kmpackages");

    if (pickupType === "homeDelivery")
      required.push("deliveryaddress", "deliverycharges");
    if (dropType === "homePickup")
      required.push("pickupaddress", "pickupcharges");

    let isValid = true;
    required.forEach((key) => {
      if (!validateField(key, inputValues[key])) isValid = false;
    });

    return isValid;
  };

  const getSubscriptionDurationError = () => {
    const bookingTypeName = String(
      bookingTypes?.[inputValues?.bookingTypes] || "",
    ).toLowerCase();
    const bookingTypeKey = String(
      inputValues?.bookingTypes || "",
    ).toLowerCase();
    const isShortSubscription = [bookingTypeName, bookingTypeKey].some(
      (value) => value.includes("short") && value.includes("subscription"),
    );
    const isSubscription = [bookingTypeName, bookingTypeKey].some((value) =>
      value.includes("subscription"),
    );

    if (!isSubscription) return "";

    const start = moment(
      `${inputValues?.startdate} ${inputValues?.starttime}`,
      "YYYY-MM-DD HH:mm",
    );
    const end = moment(
      `${inputValues?.enddate} ${inputValues?.endtime}`,
      "YYYY-MM-DD HH:mm",
    );
    const durationInDays = moment.duration(end.diff(start)).asDays();

    if (!start.isValid() || !end.isValid()) {
      return "Select a valid start and end date/time.";
    }

    if (isShortSubscription && (durationInDays < 7 || durationInDays > 29)) {
      return "Short subscription booking type duration must be 7 days and less than 29 days.";
    }

    if (!isShortSubscription && durationInDays <= 29) {
      return "Subscription booking type duration must be more than 29 days.";
    }

    return "";
  };

  const validateCustomerFields = () => {
    let isValid = true;

    const requiredFields = ["mobile", "customerName"];
    requiredFields.forEach((field) => {
      const value = inputValues[field];
      if (!validateField(field, value)) {
        isValid = false;
      }
    });

    return isValid;
  };

  const postVehicleBooking = async () => {
    if (postLoading) return; // prevent double submit
    setPostLoading(true);

    toast.loading("Processing... Please wait", {
      id: "postbooking",
      position: "bottom-center",
    });

    const start = moment(
      `${inputValues?.startdate} ${inputValues?.starttime}`,
      "YYYY-MM-DD HH:mm",
    );

    const end = moment(
      `${inputValues?.enddate} ${inputValues?.endtime}`,
      "YYYY-MM-DD HH:mm",
    );

    let totalNoOfDays;

    if (!start.isValid() || !end.isValid()) {
    } else {
      const duration = moment.duration(end.diff(start));
      const hours = duration.asHours();

      totalNoOfDays = hours / 24;
    }

    if (showButton && !inputValues?.customerId && !customerInfo) {
      toast.dismiss("postbooking");
      setPostLoading(false);
      toast.error("Please add the new customer before saving the inquiry");
      return;
    }

    const isValid = validateAll();

    if (!selectedVehicle) {
      toast.dismiss("postbooking");
      setPostLoading(false);
      toast.error("Search the available vehicles");
      return;
    }

    if (!isValid) {
      toast.dismiss("postbooking");
      setPostLoading(false);
      toast.error("Please fix the errors before saving inquiry");
      return;
    }

    const subscriptionDurationError = getSubscriptionDurationError();
    if (subscriptionDurationError) {
      toast.dismiss("postbooking");
      setPostLoading(false);
      toast.error(subscriptionDurationError);
      return;
    }

    if (!inputValues?.destination) {
      toast.dismiss("postbooking");
      setPostLoading(false);
      return setErrors((prev) => ({
        ...prev,
        destination: "Enter destination to generate the inquiry",
      }));
    }

    const pickupTypeAddress = hubs?.find(
      (item) => inputValues?.hub === item?.id,
    )?.hubAddress;

    const deliveryTypeAddress = hubs?.find(
      (item) => inputValues?.hub === item?.id,
    )?.hubAddress;

    if (Object.keys(inputValues).length > 9) {
      try {
        const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            totalNoOfDays,
            bookFrom: inputValues?.startdate + "T" + inputValues?.starttime,
            bookTo: inputValues?.enddate + "T" + inputValues?.endtime,
            vehicleId: selectedVehicle?.id,
            vehicleRegistrationNo: selectedVehicle?.registrationNo,
            vehicleName: selectedVehicle?.name,
            customerName: inputValues?.customerName,
            customerMobile: inputValues?.mobile,
            customerEmail: inputValues?.email,
            customerId: inputValues?.customerId
              ? inputValues?.customerId
              : customerInfo?.id,
            bookingStatus: fleetBookingStatus,
            packageId: Number(selectedVehicle?.packageId),
            cityId: inputValues?.city,
            hubId: inputValues?.hub,
            source: "admin",
            costToCustomer: calculateFinalPrice()?.finalPrice,
            discountPercentage: Number(
              getDiscountDetails()?.discountPercentage,
            ),
            discountAmount: getDiscountDetails()?.discountAmount,
            securityDeposit: selectedVehicle?.securityDeposit,
            taxAmount: taxAmount,
            pickupAddress: inputValues?.pickupaddress
              ? inputValues?.pickupaddress
              : pickupTypeAddress,
            deliveryAddress: inputValues?.deliveryaddress
              ? inputValues?.deliveryaddress
              : deliveryTypeAddress,
            pickupCharges: Number(inputValues?.pickupcharges) || 0,
            deliveryCharges: Number(inputValues?.deliverycharges) || 0,
            bookingHrs: selectedVehicle?.totalTripDurationInHrs,
            weekdayRent: selectedVehicle?.weekdayRent,
            weekendRent: selectedVehicle?.weekendRent,
            vehicleGroupId: selectedVehicle?.vehicleGroupId,
            weekdayHrs: selectedVehicle?.weekdayHrs,
            weekendHrs: selectedVehicle?.weekendHrs,
            overallFreeKm: selectedVehicle?.totalFreeKms,
            destination: inputValues?.destination || null,
            deliveryType: pickupType,
            deliveryTypeInt: pickupType === "homeDelivery" ? 1 : 0,
            pickupTypeInt: dropType === "homePickup" ? 1 : 0,
            pickupType: dropType,
            deliveryHubId: inputValues?.hub,
            pickupHubId: inputValues?.hub,
            isTestData: false,
            bookingHistory: {
              agentId: profile?.id,
              agentName: profile?.name,
              emailId: profile?.email,
              action: "Inquiry Generated",
            },
            bookingType: inputValues?.bookingTypes,
            packageSelectedKey: selectedVehicle?.packageSelectedKey,
            vehicleType: selectedVehicle?.vehicleType,
          }),
        });

        const data = await response.json();

        toast.dismiss("postbooking");
        setPostLoading(false);

        if (data?.statusCode === "0100") {
          toast.success("Inquiry saved successfully!", {
            position: "bottom-center",
          });

          setActiveItem("View all Inquiry");
        } else {
          toast.error(data?.message || "Something went wrong!", {
            position: "bottom-center",
          });
        }

        return data;
      } catch (error) {
        toast.dismiss("postbooking");
        setPostLoading(false);

        toast.error("API failed, please try again!", {
          position: "bottom-center",
        });

        return console.error("Error fetching Hub Names:", error);
      }
    } else {
      toast.dismiss("postbooking");
      setPostLoading(false);
      toast.error("Fill the Basic customer and trip details");
    }
  };

  useEffect(() => {
    fetchcity().then((response) => {
      if (response) {
        setCities(response); // Keep this for later use if needed

        // Use response directly instead of cities
        setdefaultbookinginput((prevInputs) =>
          prevInputs.map((input) => {
            if (input.value === "city") {
              return {
                ...input,
                subCategory: Object.entries(response).map(([key, value]) => ({
                  sublabel: value,
                  item: key,
                })),
                isEnable: true,
              };
            }
            if (input.value === "kmpackages") {
              return {
                ...input,
                subCategory: Object.entries({
                  140: 140,
                  320: 320,
                  500: 500,
                  620: 620,
                }).map(([key, value]) => ({
                  sublabel: value,
                  item: key,
                })),
                isEnable: true,
              };
            }
            if (input.value === "bookingTypes") {
              return {
                ...input,
                subCategory: Object.entries(bookingTypes).map(
                  ([key, value]) => ({
                    sublabel: value,
                    item: key,
                  }),
                ),
                isEnable: true,
              };
            }
            return input;
          }),
        );
      }
    });
  }, []);

  const fetchAvailableVehicles = async () => {
    // If user searched a mobile that resulted in "new customer" (showButton === true),
    // require the user to click Add Customer before searching vehicles.
    if (showButton && !inputValues?.customerId && !customerInfo) {
      return toast.error(
        "Please add the new customer before searching available vehicles",
      );
    }

    if (!inputValues?.customerName || inputValues.customerName.length === 0) {
      return toast.error("Enter Customer Name");
    }

    if (!inputValues.startdate || !inputValues.starttime)
      return toast.error("Select start date/time");
    if (!inputValues.enddate || !inputValues.endtime)
      return toast.error("Select end date/time");
    if (!inputValues.city) return toast.error("Select city");
    if (!inputValues.hub) return toast.error("Select hub");
    if ((isDailyRental || isElectricRental) && !inputValues.kmpackages)
      return toast.error("Select KM package");

    const subscriptionDurationError = getSubscriptionDurationError();
    if (subscriptionDurationError)
      return toast.error(subscriptionDurationError);

    setLoading(true);
    try {
      let query = "";

      if (inputValues?.startdate && inputValues?.starttime) {
        query += `startDate=${inputValues.startdate}T${inputValues.starttime}`;
      }

      if (inputValues?.enddate && inputValues?.endtime) {
        query += `&endDate=${inputValues.enddate}T${inputValues.endtime}`;
      }

      if (inputValues?.city) {
        query += `&cityId=${inputValues.city}`;
      }

      if ((isDailyRental || isElectricRental) && inputValues?.kmpackages) {
        query += `&freeKmValue=${inputValues.kmpackages}`;
      }

      let apiUrlEndpoint = isDailyRental
        ? `${apiUrl}/api/v2/vehicle-bookings-v2/search-vehicles-panel?${query}`
        : isElectricRental
          ? `${apiUrl}/api/v2/vehicle-bookings-v2/search-vehicles-panel-ev-car?${query}`
          : isBikesRental
            ? `${apiUrl}/api/v2/vehicle-bookings-v2/search-vehicles-panel-bike?${query}`
            : `${apiUrl}/api/subscriptionbookings/search-availability?${query}`;

      const response = await fetch(apiUrlEndpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });

      const data = await response.json();
      if (data?.statusCode === "0100" && data?.dataValues?.result === -1) {
        setLoading(false);
        toast.error(
          data?.dataValues?.result?.msg || data?.dataValues?.result?.message,
          {
            position: "top-end",
            style: {
              background: "red",
              color: "white",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        console.error("Unexpected API response:", data);
      } else if (data?.statusCode === "0100") {
        const filterISSoldOut = data?.dataValues?.filter(
          (item) => item?.isSoldOut === false,
        );

        setAvailableVehicles(data?.dataValues);
        setFilterAvailableVehicles(data?.dataValues);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(data?.msg || data?.message, {
          position: "top-end",
          style: {
            background: "red",
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }
  };

  const tripdetailsInput = [
    {
      label: "Pickup Type",
      type: "tab",
      value: "pickuptype",
      subCategory: ["Self Pickup", "Delivery to Customer"],
      defailtvalues: ["hubDelivery", "homeDelivery"],
    },
    {
      label: "Drop Type",
      type: "tab",
      value: "droptype",
      subCategory: ["Self Drop", "Pickup from Customer"],
      defailtvalues: ["hubPickup", "homePickup"],
    },
  ];

  const deliveryInputs = {
    pickuptype: [
      {
        label: "Delivery Address",
        type: "text",
        value: "deliveryaddress",
        allowOnlyNumbers: false,
      },
      {
        label: "Delivery Charges",
        type: "text",
        value: "deliverycharges",
        allowOnlyNumbers: true,
      },
    ],
    droptype: [
      {
        label: "Pickup Address",
        type: "text",
        value: "pickupaddress",
        allowOnlyNumbers: false,
      },
      {
        label: "Pickup Charges",
        type: "text",
        value: "pickupcharges",
        allowOnlyNumbers: true,
      },
    ],
  };

  const getUniqueInputs = (inputs) => {
    const seen = new Set();
    return inputs.filter((input) => {
      if (seen.has(input.value)) return false;
      seen.add(input.value);
      return true;
    });
  };

  const addCustomer = async () => {
    if (!validateCustomerFields()) {
      // toast.error("Please enter valid Mobile, Name, and Email");
      return;
    }

    try {
      const response = await fetch(
        `${apiUrl}/api/users/verifycustomerpresave`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            name: inputValues?.customerName,
            email: inputValues?.email || null,
            mobile: inputValues?.mobile,
            username: inputValues?.email || null,
            tenantId: 1,
            password: "new@123",
          }),
        },
      );

      const data = await response.json();
      if (data?.statusCode === "0100") {
        await postUser();
      } else {
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }
  };

  const postUser = async () => {
    let payload = {
      name: inputValues?.customerName || "",
      email: inputValues?.email || "",
      mobile: inputValues?.mobile || "",
      username: inputValues?.email || "",
      tenantId: 1,
      password: "new@123",
      isVerified: 1,
    };

    try {
      const response = await fetch(`${apiUrl}/api/users`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        const newCustomer = data?.dataValues;

        setCustomerInfo(newCustomer);
        setShowButton(false);

        setInputValues((prev) => ({
          ...prev,
          customerId: newCustomer?.id,
        }));
      } else {
        toast.error(
          data?.message ||
          data?.msg ||
          "Something went wrong while adding customer",
          {
            position: "top-end",
            style: {
              background: "red",
              color: "white",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        console.error("Unexpected API response:", data);
      }
    } catch (error) {
      console.error("Error during approval:", error);
    }
  };

  const selectedDuration = useMemo(() => {
    const start = moment(
      `${inputValues?.startdate || ""} ${inputValues?.starttime || ""}`,
      "YYYY-MM-DD HH:mm",
      true,
    );
    const end = moment(
      `${inputValues?.enddate || ""} ${inputValues?.endtime || ""}`,
      "YYYY-MM-DD HH:mm",
      true,
    );

    if (!start.isValid() || !end.isValid() || !end.isAfter(start)) {
      return "";
    }

    const totalMinutes = end.diff(start, "minutes");
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return `${days} ${days === 1 ? "day" : "days"}, ${hours} ${hours === 1 ? "hour" : "hours"
      }, ${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
  }, [
    inputValues?.startdate,
    inputValues?.starttime,
    inputValues?.enddate,
    inputValues?.endtime,
  ]);

  return (
    <div>
      <h1 className="text-xl mt-4 font-bold">Booking Search</h1>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-4 mb-4 shadow-lg">
        {/* Left Section */}
        <div className="md:col-span-9 bg-white rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 p-4 gap-4 mt-4">
            {customerInput.map((input, index) => (
              <div key={index}>
                {input.type === "autocomplete" ? (
                  <Autocomplete
                    fullWidth
                    freeSolo
                    options={userList}
                    getOptionLabel={(option) =>
                      typeof option === "object"
                        ? option?.mobile
                          ? String(option.mobile)
                          : ""
                        : String(option ?? "")
                    }
                    onChange={(event, newValue) =>
                      handleInputChange(newValue, input.value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={input.label}
                        value={inputValues[input.value] || ""}
                        error={Boolean(errors[input.value])}
                        helperText={errors[input.value] || ""}
                        onChange={(event) =>
                          handleInputChange(event, input.value)
                        }
                      />
                    )}
                  />
                ) : (
                  <TextField
                    fullWidth
                    type={input.type}
                    label={input.label}
                    disabled={
                      input.value === "customerName" || input.value === "email"
                        ? !showButton // ✅ disable when user exists, enable when new
                        : input?.isEnable
                    }
                    value={inputValues[input.value] || ""}
                    onChange={(event) => handleInputChange(event, input.value)}
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(errors[input.value])} // ✅ show red border
                    helperText={errors[input.value] || ""} // ✅ show error message
                    inputProps={
                      input.type === "time"
                        ? { step: 900 } // ✅ only for time fields → 00,15,30,45 mins
                        : {}
                    }
                  />
                )}
              </div>
            ))}
          </div>

          <div className="flex justify-end">
            {showButton && (
              <button
                onClick={addCustomer}
                className="inline-flex flex justify-center items-center mx-auto px-6 py-3 border border-transparent 
               text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
              >
                Add Customer
              </button>
            )}
          </div>

          {/* <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={isElectric}
                onChange={(e) => setIsElectric(e.target.checked)}
              />

              <div className="ring-1 ring-gray-900 bg-gradient-to-r from-rose-400 to-red-900 rounded-full duration-300 after:duration-300 w-12 h-4 shadow-inner peer-checked:bg-gradient-to-r peer-checked:from-emerald-500 peer-checked:to-emerald-900 peer-focus:ring-2 peer-focus:ring-gray-900 after:content-[''] after:rounded-full after:absolute after:h-6 after:w-6 after:bg-gray-50 after:-top-1 after:-left-1 after:flex after:justify-center after:items-center after:border-2 after:border-gray-900 peer-checked:after:translate-x-7" />
            </label>

            <span className="text-sm font-semibold">
              {isElectric ? "Electric" : "Normal"}
            </span>
          </div> */}

          <div className="grid grid-cols-1 md:grid-cols-4 p-4 gap-4">
            {defaultbookingInput
              .filter(
                (input) =>
                  input.value !== "kmpackages" ||
                  isDailyRental ||
                  isElectricRental,
              )
              .map((input, index) => (
                <div key={index}>
                  {input.type === "autocomplete" ? (
                    <Autocomplete
                      fullWidth
                      freeSolo
                      options={userList}
                      getOptionLabel={(option) =>
                        typeof option === "object"
                          ? option?.mobile || ""
                          : option
                      }
                      onChange={(event, newValue) =>
                        handleInputChange(newValue, input.value)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={input.label}
                          value={inputValues[input.value] || ""}
                          InputLabelProps={{ shrink: true }}
                          onChange={(event) =>
                            handleInputChange(event, input.value)
                          }
                        />
                      )}
                    />
                  ) : input.type === "dropdown" ? (
                    <FormControl fullWidth>
                      <InputLabel>{input.label}</InputLabel>
                      <Select
                        value={inputValues[input.value] || ""}
                        onChange={(event) =>
                          handleInputChange(event, input.value)
                        }
                        label={input.label}
                        defaultValue=""
                      >
                        {input?.subCategory.map((item, index) => (
                          <MenuItem key={index} value={item?.item}>
                            {item?.sublabel}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : input.type === "time" ? (
                    <FormControl fullWidth>
                      <InputLabel>{input.label}</InputLabel>
                      <Select
                        value={inputValues[input.value] || ""}
                        disabled={
                          isSubscriptionBooking && input.value === "endtime"
                        }
                        onChange={(event) =>
                          handleInputChange(event.target.value, input.value)
                        }
                        error={Boolean(errors[input.value])}
                        helperText={errors[input.value] || ""}
                        label={input.label}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 48 * 6.5,
                              width: 150,
                            },
                          },
                        }}
                      >
                        {Array.from({ length: 24 * 2 }).map((_, i) => {
                          const hours = Math.floor(i / 2);
                          const minutes = i % 2 === 0 ? "00" : "30";
                          const time = `${String(hours).padStart(
                            2,
                            "0",
                          )}:${minutes}`;

                          return (
                            <MenuItem
                              key={time}
                              value={time}
                              sx={{ height: 48 }}
                            >
                              {time}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : (
                    <TextField
                      fullWidth
                      type={input.type}
                      label={input.label}
                      disabled={input?.isEnable}
                      value={inputValues[input.value] || ""}
                      onChange={(event) =>
                        handleInputChange(event, input.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(errors[input.value])}
                      helperText={errors[input.value] || ""}
                      inputProps={
                        input?.value?.toLowerCase() === "enddate"
                          ? {
                            min: inputValues?.startdate
                              ? new Date(inputValues.startdate)
                                .toISOString()
                                .split("T")[0] // ✅ ensure Date object
                              : new Date().toISOString().split("T")[0], // fallback to today if start date is empty
                          }
                          : {
                            min: new Date().toISOString().split("T")[0],
                          }
                      }
                    />
                  )}
                </div>
              ))}
          </div>

          <div className="w-full flex flex-col md:flex-row md:items-center md:justify-end gap-3 mb-4 md:mb-0 px-6">
            {selectedDuration && (
              <div className="inline-flex items-center gap-2 rounded-lg border border-orange-100 bg-orange-50 px-3 py-2 shadow-sm">
                <div className="flex h-7 w-7 items-center justify-center rounded-md bg-orange-100">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-orange-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 8v4l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>

                <div className="flex items-center gap-2 text-sm">
                  <span className="font-medium text-gray-500">
                    Selected Duration
                  </span>

                  <span className="font-semibold text-gray-900">
                    {selectedDuration}
                  </span>
                </div>
              </div>
            )}
            <button
              onClick={fetchAvailableVehicles}
              disabled={showButton && !inputValues?.customerId && !customerInfo}
              className={`w-full md:w-auto px-6 py-3 rounded-lg text-white font-semibold shadow focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 ${showButton && !inputValues?.customerId && !customerInfo
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              Search Available Vehicles
            </button>
          </div>

          <div className="flex justify-end mt-6 px-4">
            {/* Filters Section */}
            {filterAvailbaleVehciles.length > 0 && (
              <div className="w-full md:w-auto bg-white rounded-xl shadow p-4 flex flex-col md:flex-row gap-4 items-center mb-3">
                {/* Transmission */}
                <div className="w-full md:w-40">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Transmission
                  </label>
                  <select
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring focus:ring-indigo-200 focus:outline-none"
                    value={selectedTransmission}
                    onChange={(e) => setSelectedTransmission(e.target.value)}
                  >
                    <option value="">All</option>
                    {Object.keys(transmissionType)
                      .filter((key) => key !== "inverted")
                      .map((key) => (
                        <option key={key} value={key}>
                          {transmissionType[key]}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Fuel */}
                <div className="w-full md:w-40">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Fuel
                  </label>
                  <select
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring focus:ring-indigo-200 focus:outline-none"
                    value={selectedFuel}
                    onChange={(e) => setSelectedFuel(e.target.value)}
                  >
                    <option value="">All</option>
                    {Object.keys(fuelType)
                      .filter((key) => key !== "inverted")
                      .map((key) => (
                        <option key={key} value={key}>
                          {fuelType[key]}
                        </option>
                      ))}
                  </select>
                </div>

                {/* Body Type */}
                <div className="w-full md:w-40">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Body Type
                  </label>
                  <select
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring focus:ring-indigo-200 focus:outline-none"
                    value={selectedBodyType}
                    onChange={(e) => setSelectedBodyType(e.target.value)}
                  >
                    <option value="">All</option>
                    {Object.keys(vehicleBodyType)
                      .filter((key) => key !== "inverted")
                      .map((key) => (
                        <option key={key} value={key}>
                          {vehicleBodyType[key]}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="w-full md:w-40">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Sort
                  </label>
                  <select
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring focus:ring-indigo-200 focus:outline-none"
                    value={priceType}
                    onChange={(e) => setPriceType(e.target.value)}
                  >
                    <option value="">All</option>

                    <option>Low to High</option>
                    <option>High to Low</option>
                  </select>
                </div>

                {/* Clear Filters */}
                <button
                  className="whitespace-nowrap bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors"
                  onClick={() => {
                    setAvailableVehicles(filterAvailbaleVehciles);
                    setSelectedBodyType("");
                    setSelectedFuel("");
                    setSelectedTransmission("");
                    setPriceType("");
                  }}
                >
                  Clear Filters
                </button>
              </div>
            )}
          </div>

          <div className="p-4 text-lg font-semibold h-[500px] overflow-scroll">
            {availableVehicles.length > 0 ? (
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-5 p-4">
                {availableVehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="bg-white rounded-xl shadow-lg p-5 flex flex-col justify-between"
                  >
                    {/* Top section */}
                    <div>
                      {/* Vehicle Image */}
                      <img
                        src={vehicle?.imageUrl}
                        alt="vehicle image"
                        className="w-40 h-24 object-cover rounded-md mb-3"
                      />

                      {/* Vehicle Details */}
                      <div className="gap-y-1 text-xs">
                        <div>
                          <span className="font-medium text-gray-600">
                            Booking Duration:
                          </span>{" "}
                          {vehicle.totalHrs} hrs
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Free Km:
                          </span>{" "}
                          {vehicle.totalFreeKms} kms
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Vehicle Name:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.name}
                          </span>
                        </div>
                        {/* <div>
                          <span className="font-medium text-gray-600">
                            Vehicle No:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.registrationNo}
                          </span>
                        </div> */}
                        <div>
                          <span className="font-medium text-gray-600">
                            Transmission:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.transmissionTypeText}
                          </span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Fuel:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.fuelTypeText}
                          </span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Seating Capacity:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.seater}
                          </span>
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Body:
                          </span>{" "}
                          <span className="font-semibold text-blue-700">
                            {vehicle.bodyTypeText}
                          </span>
                        </div>
                        {String(inputValues?.bookingTypes) ===
                          String(bookingTypesDuplicate?.inverted?.electricCars) && (
                            <>
                              <div>
                                <span className="font-medium text-gray-600">
                                  Driving Range:
                                </span>{" "}
                                <span className="font-semibold text-blue-700">
                                  {vehicle.drivingRange}
                                </span>
                              </div>
                              <div>
                                <span className="font-medium text-gray-600">
                                  Charging Time:
                                </span>{" "}
                                <span className="font-semibold text-blue-700">
                                  {vehicle.chargingTime + " hrs"}
                                </span>
                              </div>
                              <div>
                                <span className="font-medium text-gray-600">
                                  Charging Type:
                                </span>{" "}
                                <span className="font-semibold text-blue-700">
                                  {vehicle.chargingType}
                                </span>
                              </div>
                            </>
                          )}
                        <div>
                          <span className="font-medium text-gray-600">
                            Base Price:
                          </span>{" "}
                          {vehicle.baseFare}
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Security:
                          </span>{" "}
                          {vehicle.securityDeposit}
                        </div>
                        <div>
                          <span className="font-medium text-gray-600">
                            Tax:
                          </span>{" "}
                          {vehicle.taxAmount}
                        </div>
                        {String(inputValues?.bookingTypes) ===
                          String(bookingTypesDuplicate?.inverted?.dailyRental) || String(inputValues?.bookingTypes) === String(bookingTypesDuplicate?.inverted?.electricCars) ? (
                          <>
                            <div>
                              <span className="font-medium text-gray-600">
                                Weekday:
                              </span>{" "}
                              {vehicle.weekdayRent}
                            </div>
                            <div>
                              <span className="font-medium text-gray-600">
                                Weekend:
                              </span>{" "}
                              {vehicle.weekendRent}
                            </div>
                          </>
                        ) : (
                          <>
                            <div>
                              <span className="font-medium text-gray-600">
                                Base Fare:
                              </span>{" "}
                              {vehicle.baseFare}
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Bottom section */}
                    <div className="pt-3 border-t mt-2">
                      <div className="font-semibold text-gray-800 mb-3">
                        Total: {vehicle.totalRent}
                      </div>

                      <button
                        disabled={vehicle?.isSoldOut}
                        onClick={() => setSelectedVehicle(vehicle)}
                        className={`w-full text-sm font-medium rounded-md py-2 transition-colors duration-200
        ${selectedVehicle?.id === vehicle?.id
                            ? "bg-green-600 text-white border-2 border-green-800 shadow-lg"
                            : vehicle?.isSoldOut
                              ? "bg-red-300 text-black border-2 border-red-300 shadow-lg"
                              : "bg-white text-gray-800 border border-gray-400 hover:bg-gray-100"
                          }`}
                      >
                        {selectedVehicle?.id === vehicle?.id
                          ? "Selected"
                          : vehicle?.isSoldOut
                            ? "Sold Out"
                            : "Select"}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : loading ? (
              <>
                <div className="flex flex-col items-center h-40 justify-center">
                  <BlinkBlur
                    color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]}
                  />
                </div>
              </>
            ) : (
              <div className="text-center my-6">
                Available Vehicle Details and Rent Will display here
              </div>
            )}
          </div>
        </div>
      </div>
      {selectedVehicle && (
        <div className="md:col-span-3 space-y-6 bg-white p-4 rounded-lg mt-6 shadow-xl mb-4">
          <div className="grid grid-cols-3">
            {" "}
            {tripdetailsInput.map((input, index) => (
              <div key={index}>
                <h1 className="font-medium text-md mb-4">{input.label}</h1>
                <div className="flex gap-4">
                  {input.subCategory.map((option, i) => (
                    <button
                      key={i}
                      onClick={() => {
                        if (input.value === "pickuptype") {
                          setPickupType(input.defailtvalues[i]);
                          setDiscountMode(null);

                          setInputValues((prev) => ({
                            ...prev,
                            deliveryaddress: null || "",
                            deliverycharges: 0,
                            discount: 0,
                            destination: null,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            deliveryaddress: "",
                            deliverycharges: "",
                            pickupaddress: "",
                            pickupcharges: "",
                          }));
                        } else {
                          setDropType(input.defailtvalues[i]);
                          setDiscountMode(null);

                          setInputValues((prev) => ({
                            ...prev,
                            pickupaddress: null || "",
                            pickupcharges: 0,
                            discount: 0,
                            destination: null,
                          }));
                          setErrors((prev) => ({
                            ...prev,
                            deliveryaddress: "",
                            deliverycharges: "",
                            pickupaddress: "",
                            pickupcharges: "",
                          }));
                        }
                      }}
                      className={`px-4 py-2 text-xs rounded-md ${(input.value === "pickuptype" &&
                        pickupType === input.defailtvalues[i]) ||
                        (input.value === "droptype" &&
                          dropType === input.defailtvalues[i])
                        ? "bg-blue-100 border border-blue-500 shadow-md text-black"
                        : "bg-white text-black border"
                        }`}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            <label className="block">
              <span className="block text-lg font-medium text-gray-700 mb-1">
                Discount Type
              </span>
              <select
                value={discountMode === null ? "" : discountMode.toString()}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setDiscountMode(null);
                  } else {
                    setDiscountSelection(false);
                    setDiscountMode(e.target.value === "true"); // ✅ ensures boolean
                  }
                }}
                className="w-40 rounded-md border border-gray-300 bg-white py-2 px-3 text-sm shadow-sm"
              >
                <option value="">Select</option>
                <option value="false">By Percentage</option>
                <option value="true">By Amount</option>
              </select>
            </label>
          </div>

          {(() => {
            let inputs = [];
            if (pickupType === "homeDelivery") {
              inputs = inputs.concat(deliveryInputs.pickuptype);
            }
            if (dropType === "homePickup") {
              inputs = inputs.concat(deliveryInputs.droptype);
            }

            const uniqueInputs = getUniqueInputs(inputs);

            return (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                {uniqueInputs.map((input, index) => (
                  <TextField
                    key={index}
                    fullWidth
                    label={input.label}
                    type={input.type}
                    InputLabelProps={{ shrink: true }}
                    value={inputValues[input.value] || ""}
                    onChange={(event) => handleInputChange(event, input.value)}
                    onKeyDown={(e) => {
                      if (input.allowOnlyNumbers) {
                        const allowed = [
                          "Backspace",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                          "Delete",
                          ".",
                        ];
                        if (
                          !/^[0-9]$/.test(e.key) &&
                          !allowed.includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }
                    }}
                    error={Boolean(errors[input.value])}
                    helperText={errors[input.value] || ""}
                  />
                ))}

                {(pickupType || dropType) && (
                  <>
                    <TextField
                      fullWidth
                      label="Destination"
                      InputLabelProps={{ shrink: true }}
                      value={inputValues.destination || ""}
                      onChange={(e) => handleInputChange(e, "destination")}
                      error={Boolean(errors.destination)}
                      helperText={errors.destination || ""}
                    />

                    <TextField
                      fullWidth
                      label="Discount"
                      InputLabelProps={{ shrink: true }}
                      value={inputValues.discount || ""}
                      onChange={(e) =>
                        /^\d*$/.test(e.target.value) &&
                        handleInputChange(e, "discount")
                      }
                    />
                  </>
                )}
              </div>
            );
          })()}
          {discountSelection && (
            <p className="text-end text-red-600">
              Please select the discount type
            </p>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
            <div className="relative group">
              <button
                type="button"
                className="w-full px-4 py-3 rounded-lg bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700 transition"
              >
                Fare Breakdown
              </button>

              {/* Tooltip */}
              <div className="absolute text-white invisible opacity-0 group-hover:visible group-hover:opacity-100 bottom-full left-1/2 -translate-x-1/2 mb-3 w-72 transition-all duration-300 ease-out transform group-hover:translate-y-0 translate-y-2">
                <div className="relative p-4 bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md rounded-2xl border border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)]">
                  <div className="space-y-3 text-sm text-white">
                    <div className="flex justify-between">
                      <span>Base</span>
                      <span>{selectedVehicle?.baseFare ?? "-"}</span>
                    </div>

                    {inputValues?.discount ? (
                      <div className="flex justify-between">
                        <span>Discount {discountMode ? "₹" : "%"}</span>
                        <span className="font-medium">
                          {inputValues.discount || "-"}
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}

                    {inputValues?.discount ? (
                      <div className="flex justify-between">
                        <span>Discounted Base Amount</span>
                        <span>
                          {calculateFinalPrice()?.discountedBase ?? "-"}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="flex justify-between">
                      <span>Security Deposit</span>
                      <span>{selectedVehicle?.securityDeposit ?? "-"}</span>
                    </div>

                    {inputValues?.deliverycharges ? (
                      <div className="flex justify-between">
                        <span>Delivery Charge</span>
                        <span>{inputValues.deliverycharges}</span>
                      </div>
                    ) : (
                      <></>
                    )}

                    {inputValues?.pickupcharges ? (
                      <div className="flex justify-between">
                        <span>Pickup Charge</span>
                        <span>{inputValues.pickupcharges}</span>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="flex justify-between">
                      <span>Tax</span>
                      <span>{taxAmount ?? "-"}</span>
                    </div>

                    <div className="flex justify-between font-semibold">
                      <span>Total</span>
                      <span>{calculateFinalPrice()?.finalPrice}</span>
                    </div>
                  </div>

                  {/* Decorative layers */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-indigo-500/10 to-purple-500/10 blur-xl opacity-50" />
                  <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 bg-gradient-to-br from-gray-900/95 to-gray-800/95 rotate-45 border-r border-b border-white/10" />
                </div>
              </div>
            </div>

            {/* Save as Inquiry button */}
            <button
              type="button"
              onClick={postVehicleBooking}
              disabled={showButton && !inputValues?.customerId && !customerInfo}
              className={`w-full h-11 rounded-lg text-white text-base font-semibold transition ${showButton && !inputValues?.customerId && !customerInfo
                ? "bg-green-300 cursor-not-allowed"
                : "bg-green-500 hover:bg-green-600"
                }`}
            >
              Save as Inquiry
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Addinquiry;
